// extracted by mini-css-extract-plugin
export default {"navigateActionContainer":"styles_navigateActionContainer__UC4De","body":"styles_body__T-Zq9","documents":"styles_documents__ZRRzG"};